import GraphApi from '../../api/Graphs'



/**
 * GraphManager
 * Object to help with code reduction/repetition and to improve code quality
 * @type {{applyCustomDate: (function(*)), hideCustomDate: (function(*)), showCustomDate: (function(*)), setToday: (function(*)), setDateStep: (function(*, *=)), handleGraphType: (function(*)), dateForward: (function(*)), dateBackward: (function(*)), graphLoading: (function(*)), graphDidLoad: (function(*)), graphDidFail: (function(*, *)), graphColorGradientsByType: (function(*, *): *)}}
 */
let GraphManager = {
  applyCustomDate(context) {
    let self = context;
    let fromDate = moment(self.customDate.fromDate, 'DD-MM-YYYY');
    let toDate = moment(self.customDate.toDate, 'DD-MM-YYYY');
    self.$nextTick(() => {
      let daysDifference = toDate.diff(fromDate, 'days');
      self.graph.fromDate = fromDate.format('YYYY-MM-DD');
      self.graph.toDate = toDate.format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.format('Do MMM YY');
      self.visualDate.toDate = toDate.format('Do MMM YY');

      /**
       * Set the date difference for the graph step function
       * this allows the left and right navigational buttons to minus the amount of days selected in the date range
       * @type {number}
       */
      self.visualDate.dateStep = daysDifference;

      this.handleGraphType(context, true);
    });
  },
  /**
   * Hide custom date picker
   * @param context
   */
  hideCustomDate: function (context) {
    context.isCustomDateMode = false;
  },
  /**
   * Show custom date picker below the graph, also sets customDate to current date range on the graph.
   * @param context
   */
  showCustomDate: function (context) {
    let self = context;
    const fromDate = moment.utc(self.graph.fromDate, 'YYYY-MM-DD');
    const toDate = moment.utc(self.graph.toDate, 'YYYY-MM-DD');
    self.$nextTick(function () {
      self.customDate.fromDate = fromDate.format('DD-MM-YYYY');
      self.customDate.toDate = toDate.format('DD-MM-YYYY');
      self.isCustomDateMode = true;
    });
  },
  /**
   * Set graph to today
   * @param context
   */
  setToday: function (context) {
    let self = context;
    const fromDate = moment();
    self.$nextTick(function () {
      self.graph.fromDate = today.format('YYYY-MM-DD');
      self.visualDate.fromDate = today.format('Do MMM YY');
      self.graph.toDate = today.format('YYYY-MM-DD');
      self.visualDate.toDate = today.format('Do MMM YY');
      self.visualDate.toDateIsToday = true;
    })
  },
  /**
   * Sets date step using an integer to add or subtract by for each end of the date,
   * this change is made globaDo MMM YYy across the component (also when tab is clicked(
   * @param context
   * @param step
   */
  setDateStep: function (context, step) {
    let self = context;
    let fromDate = moment.utc();
    if (step === 0) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('day').format('Do MMM YY'),
        toDate: fromDate.endOf('day').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
    }
    if (step === 7) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('week').format('Do MMM YY'),
        toDate: fromDate.endOf('week').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('week').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('week').format('YYYY-MM-DD');
    }
    if (step === 30) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('month').format('Do MMM YY'),
        toDate: fromDate.endOf('month').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
    }
    if (step === 360) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('year').format('Do MMM YY'),
        toDate: fromDate.endOf('year').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD')
    }
    self.graph.userId = self.userId;
    self.isCustomDateMode = false;
  },
  /**
   * Set which type of caDo MMM YY to make a specific tracking type.
   * Available so far: weight, blood-glucose, ketones, blood-pressure, insulin, sleep, nutrition
   * @param context
   */
  handleGraphType: function (context, isCustom = false) {
    let self = context;
    if(isCustom === true) {
      self.type = self.graph.type;
      self.fromDate = self.customDate.fromDate;
      self.toDate = self.customDate.toDate;
      self.userId = self.graph.userId;
    }

    switch (self.type) {
      case 'activity':
        GraphApi.getActivityGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'activity-steps':
        GraphApi.getActivityStepsGraph(self.fromDate, self.toDate, self.userId, self.activeStepsType)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'weight':
        GraphApi.getWeightGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'waist-hip':
        GraphApi.getWaistGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'blood-glucose':
        GraphApi.getBloodGlucoseGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed');
          });
        break;
      case 'cholesterol':
        GraphApi.getCholesterolGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response);
          })
          .catch(function () {
            self.$emit('graphFailed');
          });
        break;
      case 'ketones':
        GraphApi.getKetonesGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'blood-pressure' :
        GraphApi.getBloodPressureGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed');
            self.$emit('graphLoading', false);
          });
        break;
      case 'hba1c':
        GraphApi.getHba1cGraph(self.fromDate, self.toDate, self.userId)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed');
            self.$emit('graphLoading', false);
          });
        break;
      case 'insulin':
        GraphApi.getInsulinGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'sleep':
        GraphApi.getSleepGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'sleep-wearable':
        GraphApi.getSleepWearableGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id, self.activeSleepType)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'nutrition':
        GraphApi.getNutritionGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed')
          });
        break;
      case 'medication':
        if (self.medTrackingId !== 0) {
          GraphApi.getMedicationGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id, self.medTrackingId)
            .then(function (response) {
              self.renderChartFromData(response);
            })
            .catch(function () {
              self.$emit('graphFailed');
            })
        }
        break;
      case 'mood':
        GraphApi.getMoodGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id)
          .then(function (response) {
            self.renderChartFromData(response)
          })
          .catch(function () {
            self.$emit('graphFailed', {});
          });
        break;
    }
  },
  /**
   * When UI button is pressed dateStep is added to both sides of the date range
   * @param context
   */
  dateForward: function (context) {
    let self = context;
    let isDateStepZero = undefined;


    const fromDate = moment(self.graph.fromDate, "YYYY-MM-DD");
    const toDate = moment(self.graph.toDate, "YYYY-MM-DD");

    if (self.visualDate.dateStep === 0 || self.visualDate.dateStep === 1) {
      self.graph.fromDate = fromDate.add(1, 'days').startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('day').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('day').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 7) {
      self.graph.fromDate = fromDate.add(1, 'weeks').startOf('week');
      self.graph.toDate = fromDate.endOf('week');
      self.visualDate.fromDate = fromDate.startOf('week').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('week').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 30) {
      self.graph.fromDate = fromDate.add(1, 'months').startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('month').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('month').format('Do MMM YY');
    }


    if (self.visualDate.dateStep === 360) {
      self.graph.fromDate = fromDate.add(1, 'years').startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('year').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('year').format('Do MMM YY')
    }

  },
  /**
   * When UI button is pressed dateStep is subtracted at both sides of the date range
   * @param context
   */
  dateBackward: function (context) {
    let self = context;

    const fromDate = moment(self.graph.fromDate, "YYYY-MM-DD");
    const toDate = moment(self.graph.toDate, "YYYY-MM-DD");

    if (self.visualDate.dateStep === 0 || self.visualDate.dateStep === 1) {
      self.graph.fromDate = fromDate.subtract(1, 'days').startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('day').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('day').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 7) {
      self.graph.fromDate = fromDate.subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('week').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('week').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('week').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 30) {
      self.graph.fromDate = fromDate.subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('month').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('month').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 360) {
      self.graph.fromDate = fromDate.subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('year').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('year').format('Do MMM YY')
    }

  },
  /**
   * Graph is loading
   * @param context
   */
  graphLoading: function (context) {
    context.graphIsLoading = true;
  },
  /**
   * When graph finished loading
   * @param context
   */
  graphDidLoad: function (context) {
    let self = context;
    self.$nextTick(function () {
      self.graphIsLoading = false;
      self.graphError = false;
    });
  },
  /**
   * When the graph failed to load, or had no data
   * @param context
   * @param options
   */
  graphDidFail: function (context, options) {
    let self = context;
    self.$nextTick(function () {
      self.graphIsLoading = false;
      self.graphError = true;
    });
  },
  /**
   * Provides a way to add a gradient to the graph, but currently not in use
   * @param context
   * @param index
   * @returns {*}
   */
  graphLineColorByType: function (context, index) {
    switch (context.type) {

      case "activity":
        if (index === 0) return "#4e2288";
        break;
      case "activity-steps":
        if (index === 0) return "#4e2288";
        break;
      case "blood-glucose":
        if (index === 0) return "#E43229";
        break;
      case "hba1c":
        if (index === 0) return "#E43229";
        break;
      case "cholesterol":
        if (index === 0) return "rgba(105,125,206, 1)";
        break;
      case "weight":
        return "#3D96DE";
      case "ketones":
        if (index === 0) {
          return "#F5950C";
        }
        if (index === 1) {
          return "red"
        }
        if (index === 2) {
          return "#68C3FF"
        }
        break;
      case "medication":
        return "#AE3463";
      case "sleep" && "sleep-wearable":
        if (index === 0) {
          return "#FEA228";
        }
        if (index === 1) {
          return "#0F3C43"
        }
        break;
      case "blood-pressure":
        if (index === 0) {
          return "rgba(163, 225, 100, 1)";
        }
        if (index === 1) {
          return "rgba(54, 147, 222, 1)";
        }
        break;
      case "insulin":
        if (index === 0) {
          return "rgba(52, 202, 185, 1)";
        }
        if (index === 1) {
          return "rgba(149, 52, 202, 1)";
        }
        if (index === 2) {
          return "rgba(254, 162, 40, 1)"
        }
        break;
      case "mood":
        return "#3123ae";
    }
  },
  /**
   * Fills graph line context with a gradient, else returns undefined
   * @param context
   * @param index
   * @returns {*}
   */
  graphColorGradientsByType: function (context, index) {
    let self = context;
    const gradient = self.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);
    if (self.type === "hba1c") {
      if (index === 0) {
        const opacity = 0.1;
        gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
        gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
        gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
        return gradient;
      }
    }
    if (self.override[index].pointBackgroundColor === '#FFFFFF') {
      const opacity = 0.1;
      switch (self.type) {

        case 'activity':

          gradient.addColorStop(0, "rgba(85, 25, 140, 1)");
          gradient.addColorStop(0.5, "rgba(85, 25, 140, 0.5)");
          gradient.addColorStop(1, 'rgba(85, 25, 140,' + 0.01 + ')');
          return gradient;

          break;

        case 'activity-steps':

          gradient.addColorStop(0, "rgba(85, 25, 140, 1)");
          gradient.addColorStop(0.5, "rgba(85, 25, 140, 0.5)");
          gradient.addColorStop(1, 'rgba(85, 25, 140,' + 0.01 + ')');
          return gradient;

          break;

        case "blood-glucose":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
            gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;

        case "cholesterol":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(105,125,206, 1)");
            gradient.addColorStop(0.5, "rgba(105,125,206, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        case "weight":
        case "waist-hip":
          gradient.addColorStop(0, "rgba(61, 150, 222, 1)");
          gradient.addColorStop(0.5, "rgba(61, 150, 222, 0.5)");
          gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
          return gradient;
          break;
        case "blood-pressure":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(163, 225, 100, 1)");
            gradient.addColorStop(0.5, "rgba(163, 225, 100, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          if (index === 1) {
            gradient.addColorStop(0, "rgba(54, 147, 222, 1)");
            gradient.addColorStop(0.5, "rgba(54, 147, 222, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        case "medication":
          gradient.addColorStop(0, "rgba(174, 52, 99, 1)");
          gradient.addColorStop(0.5, "rgba(174, 52, 99, 0.5)");
          gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
          return gradient;
          break;
        case "ketones":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(251, 183, 12, 1)");
            gradient.addColorStop(0.5, "rgba(251, 183, 12, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        case "insulin":
          if (index === 0) {
            gradient.addColorStop(0, " rgba(52, 202, 185, 1)");
            gradient.addColorStop(0.5, "rgba(52, 202, 185, 0.5) ");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }

          if (index === 1) {
            gradient.addColorStop(0, "rgba(149, 52, 202, 1)");
            gradient.addColorStop(0.5, "rgba(149, 52, 202, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }

          if (index === 2) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        case "sleep" && "sleep-wearable":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          if (index === 1) {
            gradient.addColorStop(0, "rgba(15, 60, 67,1 )");
            gradient.addColorStop(0.5, "rgba(15, 60, 67, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        case "mood":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
            return gradient;
          }
          break;
        default:
          return undefined;
      }
      return undefined;
    }
  }
};


export default GraphManager;





// WEBPACK FOOTER //
// ./src/helpers/GraphManager/index.js